import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'taskStatus'
})
export class TaskStatusPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    var ret = "";
    switch(value) {
        case 0:
            ret = "Running"
            break;
        case 1:
            ret = "Paused"
            break;
        case 2:
            ret = "Cancelled"
            break;
        case 3:
            ret = "Reassigned"
            break;
        case 4:
            ret = "Completed"
            break;
        default:
            break;
    }
    return ret;
  }

}
